export default "__VITE_ASSET__DMNT8q$5__"